
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import "./SpecialFacility.css";
import Aos from 'aos';
import './aos.css';
import React, { useState, useEffect } from 'react';


function Libraries() {
  useEffect(() => {
    Aos.init({});
  }, [])
  return (
    // <div className="facility-container">
    //   <div className="facility-box">
    //     <h2 className="facility-title">ACE International Academy Libraries</h2>
    //     <p className="facility-text">
    //       <div>
    //         The mission of ACE International Academy’s Libraries is to inspire
    //         and support its Students towards creative and intellectual
    //         achievement. ACE School Libraries cater to all age groups and offer
    //         Internet access. The libraries have a fully automated system; all
    //         transactions are handled electronically. The libraries are the
    //         intellectual heart of ACE and a hub of activity and learning. The
    //         libraries are places which ACE students can use to borrow books,
    //         learn library skills, obtain access to a vast quantity of
    //         information from a variety of resources, perform research, and hear
    //         stories read aloud, talk with the librarians about books, or just
    //         enjoy a quiet place to read and learn
    //       </div>
    //     </p>
    //   </div>
    // </div>
    <Container className="my-5">
      <Row>
        <Col xs={6} md={5}>
          <div data-aos="flip-left" data-aos-duration="2500">
            <Image
              src="imagesspecialfacilities/Library.jpg"
              rounded
              style={{ width: '100%', objectFit: 'cover', marginTop: '20px', boxShadow: ' rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px, rgba(0, 0, 0, 0.35) 0px 5px 15px' }}
            />
          </div>
        </Col>
        <Col xs={6} md={7}>
          <div className="facility-text">
            <h2 className="facility-title">ACE International Academy Libraries</h2>
            <br />
            <p>
              The mission of ACE International Academy’s Libraries is to inspire
              and support its Students towards creative and intellectual
              achievement. ACE School Libraries cater to all age groups and offer
              Internet access. The libraries have a fully automated system; all
              transactions are handled electronically. The libraries are the
              intellectual heart of ACE and a hub of activity and learning. The
              libraries are places which ACE students can use to borrow books,
              learn library skills, obtain access to a vast quantity of
              information from a variety of resources, perform research, and hear
              stories read aloud, talk with the librarians about books, or just
              enjoy a quiet place to read and learn
            </p>
          </div>
        </Col>
      </Row>

    </Container>
  );
}

export default Libraries;
